<div class="row">
  <div class="col-12 text-right">
      <button class="btn btn-default btn-sm" (click)="back()"><i class="fas fa-chevron-left"> Back</i></button> &nbsp;
      <button class="btn btn-warning btn-sm" (click)="cancel()"><i class="fas fa-times"></i> Reset</button> &nbsp;
      <button class="btn btn-primary btn-sm" (click)="update()"><i class="fas fa-edit"></i> Update</button>
  </div>

  <div class="col-md-5">
    <h3>No-owned keywords</h3>
    <div class="p-2 grantSelectBox card">
      <div *ngIf="loading">
        <div class="loader">Loading...</div>
      </div>
      <div *ngFor="let opt of notGrantedList | groupBy: 'shortCode'">
        <p class="text-muted">{{opt.key}} <span class="small">- shortcode</span></p>
        <div *ngFor="let sel of opt.value; index as i" class="pl-2 small mb-2 hoverable" (click)="onSelect(sel, 'from')" id="{{sel.id}}">
          <b>Keyword</b>: {{sel.keyword}} | <b>Operator</b>: {{sel.operator}}<span *ngIf="sel.affiliate"> | <b>Affiliate</b>: {{sel.affiliate}}</span>
          <!-- <div *ngIf=" opt.value.length> 1">
        </div> -->
          <hr class="m-1">

        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 align-self-center">
    <button (click)="submit()" class="btn btn-default d-block mx-auto" id="fromNotGrant">
      &gt;&gt;
    </button>
    <button (click)="unsubmit()" class="btn btn-default mt-2 d-block mx-auto mt-3" id="toNotGrant">
      &lt;&lt; </button>
    </div>
    <div class="col-md-5">
        <h3>[{{selectedClient.username}}]-owned keywords</h3>
        <div id="grantDiv" class="p-2 grantSelectBox card">
          <div *ngIf="loading">
            <div class="loader">Loading...</div>
          </div>
          <div *ngFor="let opt of grantList | groupBy: 'shortCode'">
            <p class="text-muted">{{opt.key}} <span class="small">- shortcode</span></p>
            <div *ngFor="let sel of opt.value; index as i" class="pl-2 small mb-2 hoverable" (click)="onSelect(sel, 'to')" id="{{sel.id}}">

              <b>Keyword</b>: {{sel.keyword}} | <b>Operator</b>: {{sel.operator}}<span *ngIf="sel.affiliate"> | <b>Affiliate</b>: {{sel.affiliate}}</span>

              <hr class="m-1">
            </div>
          </div>
          <div *ngIf="!loading && isEmpty">Empty List</div>
        </div>
  </div>
</div>
